import { render, staticRenderFns } from "./GlobalChart.vue?vue&type=template&id=0ded3df0&scoped=true"
import script from "./GlobalChart.vue?vue&type=script&lang=js"
export * from "./GlobalChart.vue?vue&type=script&lang=js"
import style0 from "./GlobalChart.vue?vue&type=style&index=0&id=0ded3df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded3df0",
  null
  
)

export default component.exports